/* eslint-disable */
import React from 'react';
import { Briefcase, Plus, Search, Filter, ChevronRight } from 'lucide-react';

const cases = [
  { id: 'C-2024-089', title: 'Corporate Restructuring',       client: 'PT Maju Bersama',   type: 'Corporate',   lawyer: 'Budi Santoso',   status: 'Active',   filed: '2024-05-20', priority: 'High'   },
  { id: 'C-2024-088', title: 'Criminal Defense',              client: 'Ahmad Fauzi',        type: 'Criminal',    lawyer: 'Rina Wijaya',    status: 'Pending',  filed: '2024-05-18', priority: 'High'   },
  { id: 'C-2024-087', title: 'Commercial Contract Dispute',   client: 'CV Karya Utama',     type: 'Contract',    lawyer: 'Hendra Kusuma',  status: 'Closed',   filed: '2024-05-15', priority: 'Low'    },
  { id: 'C-2024-086', title: 'Divorce Proceedings',           client: 'Siti Rahayu',        type: 'Family',      lawyer: 'Budi Santoso',   status: 'Active',   filed: '2024-05-12', priority: 'Medium' },
  { id: 'C-2024-085', title: 'Patent Registration',           client: 'PT Nusantara Jaya',  type: 'IP/Patent',   lawyer: 'Rina Wijaya',    status: 'Active',   filed: '2024-05-10', priority: 'Medium' },
  { id: 'C-2024-084', title: 'Property Ownership Dispute',   client: 'Bapak Hendra Lim',   type: 'Property',    lawyer: 'Hendra Kusuma',  status: 'Active',   filed: '2024-05-08', priority: 'High'   },
];

const statusStyle = {
  Active:  { bg: '#f0fdf4', text: '#16a34a' },
  Pending: { bg: '#fffbeb', text: '#d97706' },
  Closed:  { bg: '#f8fafc', text: '#64748b' },
};
const priorityStyle = {
  High:   { bg: '#fef2f2', text: '#dc2626' },
  Medium: { bg: '#fffbeb', text: '#d97706' },
  Low:    { bg: '#f0fdf4', text: '#16a34a' },
};

export default function CasesPage() {
  return (
    <div style={{ maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 28 }}>
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: '#0f172a', margin: 0 }}>Cases</h1>
          <p style={{ fontSize: 14, color: '#64748b', marginTop: 4 }}>Track and manage all legal cases.</p>
        </div>
        <button style={{
          display: 'flex', alignItems: 'center', gap: 8,
          background: 'linear-gradient(135deg, #1a2d5a, #1e3a6e)',
          color: '#fff', border: 'none', borderRadius: 10,
          padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(26,45,90,0.3)',
        }}>
          <Plus size={16} /> New Case
        </button>
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <div style={{
          flex: 1, display: 'flex', alignItems: 'center', gap: 10,
          background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10,
          padding: '0 14px', height: 42, boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        }}>
          <Search size={15} color="#94a3b8" />
          <input placeholder="Search cases…" style={{ border: 'none', outline: 'none', fontSize: 14, color: '#334155', width: '100%', background: 'transparent' }} />
        </div>
        <button style={{
          display: 'flex', alignItems: 'center', gap: 8,
          background: '#fff', border: '1px solid #e2e8f0',
          borderRadius: 10, padding: '0 16px', height: 42,
          fontSize: 14, color: '#64748b', cursor: 'pointer',
        }}>
          <Filter size={15} /> Filter
        </button>
      </div>

      <div style={{ background: '#fff', borderRadius: 16, border: '1px solid #f1f5f9', overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8fafc' }}>
              {['Case ID', 'Title', 'Client', 'Type', 'Lawyer', 'Priority', 'Status', ''].map(h => (
                <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 12, color: '#64748b', fontWeight: 600, letterSpacing: 0.4 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {cases.map(c => (
              <tr key={c.id}
                style={{ borderTop: '1px solid #f1f5f9', transition: 'background 0.15s', cursor: 'pointer' }}
                onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <td style={{ padding: '14px 16px', fontSize: 13, fontWeight: 700, color: '#334155' }}>{c.id}</td>
                <td style={{ padding: '14px 16px', fontSize: 13, color: '#0f172a', fontWeight: 500 }}>{c.title}</td>
                <td style={{ padding: '14px 16px', fontSize: 13, color: '#64748b' }}>{c.client}</td>
                <td style={{ padding: '14px 16px', fontSize: 13, color: '#64748b' }}>{c.type}</td>
                <td style={{ padding: '14px 16px', fontSize: 13, color: '#64748b' }}>{c.lawyer}</td>
                <td style={{ padding: '14px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 20, background: priorityStyle[c.priority].bg, color: priorityStyle[c.priority].text }}>{c.priority}</span>
                </td>
                <td style={{ padding: '14px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 20, background: statusStyle[c.status].bg, color: statusStyle[c.status].text }}>{c.status}</span>
                </td>
                <td style={{ padding: '14px 16px' }}><ChevronRight size={15} color="#94a3b8" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
